exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".balance-new[data-v-52e71fd8]{border:1px dashed #d8dde2;padding:1.5rem;margin:0 0 1.5rem}.balance-history[data-v-52e71fd8]{border:1px solid #e4e7ea}.balance-history thead tr[data-v-52e71fd8]{border:0}.balance-history th[data-v-52e71fd8]{background-color:#e9ecef;border-top:0;border-bottom:1px solid #e4e7ea;color:#73818f;font-size:.8rem;font-weight:600;letter-spacing:.04em;text-transform:uppercase;white-space:nowrap}.balance-history td[data-v-52e71fd8],.balance-history th[data-v-52e71fd8]{padding:.4rem 1rem;vertical-align:middle}.balance-history td[data-v-52e71fd8]{border-top-color:#eef0f2}.balance-history tbody tr:first-child td[data-v-52e71fd8]{border-top:0}.balance-badge-valid[data-v-52e71fd8]{background-color:#e6f4ea;color:#1e7e34}.balance-deleted[data-v-52e71fd8]{text-decoration:line-through}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52e71fd8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/admin/js/employee/EmployeeBalanceCard.vue
// module id = rGIc
// module chunks = 0